// src/components/health/MyResultsModal.js
import { useEffect } from "react";
export default function MyResultsModal({
    open,
    onClose,
    onSelect,
    title = "어떤 운동 결과가 필요하신가요?",
    options = [
        { key: "cardio_endurance", label: "심폐지구력" },
        { key: "triple_combo", label: "3종 복합 운동" },
        { key: "strength", label: "근력" },
        { key: "power", label: "근파워" },
        { key: "muscular_endurance", label: "근지구력" },
    ],
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center"
            role="dialog"
            aria-modal="true"
            onClick={onClose}
        >
            <div className="absolute inset-0 bg-black/40" />
            <div
                className="relative z-10 w-[92vw] max-w-md rounded-2xl bg-white shadow-xl ring-1 ring-black/5"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center gap-2 px-5 pt-4">
                    <button onClick={onClose} className="flex items-center gap-1 text-blue-500 font-semibold">
                        <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden>
                            <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>이전으로</span>
                    </button>
                </div>

                <div className="px-5 pt-2 pb-4 text-center">
                    <h3 className="text-xl font-extrabold tracking-tight">{title}</h3>
                </div>

                <div className="px-4 pb-5 space-y-3">
                    {options.map((o) => (
                        <button
                            key={o.key}
                            className="w-full py-3 rounded-xl bg-gray-100 text-gray-900 font-semibold hover:bg-gray-200 active:scale-[0.99] transition"
                            onClick={() => onSelect?.(o)}
                        >
                            {o.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
